import {
    PATIENT_BLISTER_PACK_LIST_REQUEST,
    PATIENT_BLISTER_PACK_LIST_SUCCESS,
    PATIENT_BLISTER_PACK_LIST_FAILURE
} from "../../../constants"

const initialState = {
    data: null,
    loading: false,
    error: null,
    type: null,
    activeMedicationData: {
        data: null,
        loading: false,
        error: null,
        type: null,
    }
};

const patientBlisterPackList = (state = initialState, action) => {
    switch (action.type) {
        case PATIENT_BLISTER_PACK_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                data: null,
                error: null,
                type: action.types,
            };
        case PATIENT_BLISTER_PACK_LIST_SUCCESS:

            return {
                ...state,
                loading: false,
                data: action.payload,
                type: action.types,
                error: null,
            };
        case PATIENT_BLISTER_PACK_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                type: action.types,
                data: null,
            };

        case 'PATIENT_ACTIVE_MEDICATION_REQUEST':
            return {
                ...state,
                activeMedicationData: {
                    ...state.activeMedicationData,
                    loading: true,
                    data: null,
                    error: null,
                    type: action.types,
                }
            };
        case 'PATIENT_ACTIVE_MEDICATION_SUCCESS':

            return {
                ...state,
                activeMedicationData: {
                    ...state.activeMedicationData,
                    loading: false,
                    data: action.payload,
                    type: action.types,
                    error: null,
                }
            };
        case 'PATIENT_ACTIVE_MEDICATION_FAILURE':
            return {
                ...state,
                activeMedicationData: {
                    ...state.activeMedicationData,
                    loading: false,
                    error: action.payload,
                    type: action.types,
                    data: null,
                }
            };
        default:
            return state;
    }
};

export default patientBlisterPackList;
